<template>
  <div class="mainview">
    <div class="title">
      <i class="goback el-icon-arrow-left" @click="goback"></i>
      {{titleinfo}}
    </div>
    <div class="content whd-bgwhite">
      <div class="whd-news-detail" v-if="detail">
        <h1 class="tit">{{detail.title}}</h1>
        <p class="date">{{detail.create_time}}</p>
        <div class="cont" v-html="detail.content"></div>        
      </div>  
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
export default {
  name: "newsDetail",
  data() {
    return{
      titleinfo: "公告详情",
      detail: {}
    }
  },
  created() {
    this.InitFn();
  },
  methods: {
    InitFn() {
      this.axios
        .post(api.companyadmin_index_newsDetail, {id: this.$route.query.id})
        .then(response => {
          if (response.data.code == 0) {
            this.detail = response.data.info;
          } else {
          }
        })
        .catch(() => {});
    },
    goback() {
      this.$router.go(-1);
    }
  }
}
</script>